import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import Cookie from "js-cookie";
const userToken = Cookie.get("token");
const baseUrl = process.env.VUE_APP_BASE_API_URL;
Vue.use(VueAxios, axios);

Vue.use(axios);

const sendLogin = ({ state }) => {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl + "/auth/login", state.dataLogin).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};
const getUserInfo = ({ commit }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(baseUrl + "/auth/profile", {
        headers: {
          authorization: `Bearer ${userToken}`
        }
      })
      .then(
        response => {
          const res = response.data;
          resolve(response);
          if (res.data) {
            commit("SET_RESUSERINFO", res.data);
          }
        },
        error => {
          reject(error);
        }
      );
  });
};
const updatePassword = ({ state }) => {
  return new Promise((resolve, reject) => {
    axios
      .post(baseUrl + "/auth/change-password", state.temp_password, {
        headers: {
          authorization: `Bearer ${userToken}`
        }
      })
      .then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
  });
};
const getRole = ({ commit }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(baseUrl + "/role/roles", {
        params: {
          order_by: "created_at",
          order_direction: "desc"
        },
        headers: {
          authorization: `Bearer ${userToken}`
        }
      })
      .then(
        response => {
          const res = response.data;
          resolve(response);
          if (res.data) {
            commit("SET_RESROLE", res.data);
          }
        },
        error => {
          reject(error);
        }
      );
  });
};
const createRole = ({ state }) => {
  return new Promise((resolve, reject) => {
    axios
      .post(baseUrl + "/role/roles", state.temp_role, {
        headers: {
          authorization: `Bearer ${userToken}`
        }
      })
      .then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
  });
};
const updateRole = ({ state }) => {
  return new Promise((resolve, reject) => {
    axios
      .put(baseUrl + "/role/roles/" + state.idrole, state.temp_role, {
        headers: {
          authorization: `Bearer ${userToken}`
        }
      })
      .then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
  });
};
const deleteRole = ({ state }) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(baseUrl + "/role/roles/" + state.idrole, {
        headers: {
          authorization: `Bearer ${userToken}`
        }
      })
      .then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
  });
};
const getMenu = ({ commit }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(baseUrl + "/access/accesses", {
        params: {
          order_by: "name",
          order_direction: "desc"
        },
        headers: {
          authorization: `Bearer ${userToken}`
        }
      })
      .then(
        response => {
          const res = response.data;
          resolve(response);
          if (res.data) {
            commit("SET_RESMENU", res.data);
          }
        },
        error => {
          reject(error);
        }
      );
  });
};
const getAccessListu = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(baseUrl + "/role/roles/" + state.idrole + "/access", {
        params: {
          order_by: "created_at",
          order_direction: "desc"
        },
        headers: {
          authorization: `Bearer ${userToken}`
        }
      })
      .then(
        response => {
          const res = response.data;
          resolve(response);
          if (res.data) {
            commit("SET_RESACCESSLIST", res);
          }
        },
        error => {
          reject(error);
        }
      );
  });
};
const createAccess = ({ state }) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        baseUrl + "/role/roles/" + state.idrole + "/access",
        state.dataCreateAccess,
        {
          headers: {
            authorization: `Bearer ${userToken}`
          }
        }
      )
      .then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
  });
};
const deleteAccess = ({ state }) => {
  return new Promise((resolve, reject) => {
    console.log(`Bearer ${userToken}`);
    axios
      .delete(baseUrl + "/role/roles/" + state.idrole + "/access", {
        data: state.dataDeleteAccess,
        headers: {
          authorization: `Bearer ${userToken}`
        }
      })
      .then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
  });
};
const getMenuByAuth = ({ commit }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(baseUrl + "/role/roles-by-auth", {
        headers: {
          authorization: `Bearer ${userToken}`
        }
      })
      .then(
        response => {
          const res = response.data;
          resolve(response);
          if (res.data) {
            commit("SET_RESMENUAUTH", res.data);
          }
        },
        error => {
          reject(error);
        }
      );
  });
};
export default {
  sendLogin,
  getUserInfo,
  updatePassword,
  getRole,
  createRole,
  updateRole,
  deleteRole,
  getMenu,
  getAccessListu,
  createAccess,
  deleteAccess,
  getMenuByAuth
};
